import apiService from './api';
import type { FeatureFlagsState, NavPlacement, ClassificationBannerMode } from '../types/featureFlags';

export interface ModuleSettingsPayload extends FeatureFlagsState {
  navPlacement: NavPlacement;
  participantLabelSingular: string;
  participantLabelPlural: string;
  courseLabelSingular: string;
  courseLabelPlural: string;
  classificationBannerMode: ClassificationBannerMode;
}

export const getModuleSettings = async (): Promise<ModuleSettingsPayload> => {
  return await apiService.getModuleSettings();
};

export const updateModuleSettings = async (
  settings: Partial<ModuleSettingsPayload>
): Promise<ModuleSettingsPayload> => {
  return await apiService.updateModuleSettings(settings);
};
